import { useEffect, useRef } from 'react'
import { ChatMessage as ChatMessageType } from '@/types'
import { ScrollArea } from '@/components/ui/scroll-area'
import { ChatMessage } from './ChatMessage'
import { Bot } from 'lucide-react'
import { Avatar, AvatarFallback } from '@/components/ui/avatar'

interface ChatHistoryProps {
  messages: ChatMessageType[]
  isLoading: boolean
  onSuggestionClick: (suggestion: string) => void
}

const TypingIndicator = () => (
  <div className="flex items-start gap-4 justify-start animate-message-in">
    <Avatar className="h-8 w-8">
      <AvatarFallback>
        <Bot className="h-5 w-5" />
      </AvatarFallback>
    </Avatar>
    <div className="flex items-center gap-1 p-3 bg-card rounded-lg shadow-sm rounded-bl-none w-fit mt-2">
      <div className="h-2 w-2 bg-muted-foreground rounded-full animate-typing-dot-1"></div>
      <div className="h-2 w-2 bg-muted-foreground rounded-full animate-typing-dot-2"></div>
      <div className="h-2 w-2 bg-muted-foreground rounded-full animate-typing-dot-3"></div>
    </div>
  </div>
)

export const ChatHistory = ({
  messages,
  isLoading,
  onSuggestionClick,
}: ChatHistoryProps) => {
  const messagesEndRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [messages, isLoading])

  return (
    <div className="flex-1 flex flex-col min-h-0">
      <ScrollArea className="flex-1">
        <div className="container max-w-3xl mx-auto p-4 space-y-6">
          {messages.map((msg, index) => (
            <ChatMessage
              key={index}
              message={msg}
              onSuggestionClick={onSuggestionClick}
            />
          ))}
          {isLoading && <TypingIndicator />}
          <div ref={messagesEndRef} />
        </div>
      </ScrollArea>
    </div>
  )
}
